
import {
	CONSULTATION_KEY_TYPE,
	CONSULTATION_TARGET_KEY_TYPE,
	DEFAULT_TAX_ACCOUNTANT_NAME,
	TaxAccountantNameModel
} from "@/shared/model";
import * as z from "zod";
import {DEFAULT_MANAGER_INFORMATION, ManagerInformationModel} from "../../tax-corporation";

const schema = z.object({
	id: z.string(),
	department: z.string().nullable(),
	managerInformation: ManagerInformationModel.model.nullable(),
	taxAccountantName: TaxAccountantNameModel.model,
	visitedAt: z.string().nullable(),
	wroteDate: z.string().nullable(),
	visitPurpose: CONSULTATION_KEY_TYPE.nullable(),
	visitPurposeDetail: CONSULTATION_TARGET_KEY_TYPE.nullable()
});

const model = schema.transform((values) => ({
	...values
}));

export const VisitHistorySearchResModel = {schema, model};
export type IVisitHistorySearchResModel = z.infer<typeof VisitHistorySearchResModel.model>;
export const DEFAULT_VISIT_HISTORY_RES: IVisitHistorySearchResModel = {
	id: "",
	department: "",
	managerInformation: DEFAULT_MANAGER_INFORMATION,
	taxAccountantName: DEFAULT_TAX_ACCOUNTANT_NAME,
	visitedAt: null,
	wroteDate: null,
	visitPurpose: null,
	visitPurposeDetail: null
};
